module.exports = __webpack_public_path__ + "img/pin.ec3871e.svg";